import "core-js/modules/es.object.from-entries.js";
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { AllMenusQuery, Link, useLocation } from "@custom/schema";
import clsx from "clsx";
import { flow } from "es-toolkit";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { appConfig } from "../../../utils/app-config";
import { DomainProvider, getDomain, homepagePaths, useDomain } from "../../../utils/domain";
import { useFlyout } from "../../../utils/flyout";
import { useLocalization } from "../../../utils/localization";
import { addClassToMenuItems, menuItems } from "../../../utils/navigation";
import { useOperation } from "../../../utils/operation";
import { usePageTranslations } from "../../../utils/page-translations";
import { useSearchForm } from "../../../utils/search";
import { getLocalizedUrl } from "../../../utils/url";
import { useCallToAction } from "../../../utils/useCallToAction";
import { Logo } from "../../Atoms/Logo";
import { SecondaryTitle } from "../../Atoms/Typography/SecondaryTitle";
import { MenuItem } from "../../Molecules/MenuItem";
export var MobileMetaNavigationMenu = function MobileMetaNavigationMenu(param) {
  var items = param.items,
    itemsLeft = param.itemsLeft,
    title = param.title;
  var locale = useLocalization().locale;
  var hideMobileNavigation = useMobileNavigation().hideMobileNavigation;
  return /*#__PURE__*/React.createElement("div", {
    className: "MobileMetaNav"
  }, /*#__PURE__*/React.createElement(SecondaryTitle, {
    className: "visuallyhidden"
  }, title), /*#__PURE__*/React.createElement("ul", {
    className: "MobileMetaNav--list"
  }, _to_consumable_array(itemsLeft).concat(_to_consumable_array(items)).filter(function (item) {
    var _item_attributes, _item_attributes1;
    return !("attributes" in item) || !((_item_attributes = item.attributes) === null || _item_attributes === void 0 ? void 0 : _item_attributes.id) || ((_item_attributes1 = item.attributes) === null || _item_attributes1 === void 0 ? void 0 : _item_attributes1.id) !== "search";
  }).map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: item.id
    }, /*#__PURE__*/React.createElement(Link, {
      href: getLocalizedUrl({
        to: item.url,
        domain: getDomain("paraplegie_ch"),
        locale: locale
      }).url,
      onClick: hideMobileNavigation,
      className: "MobileMetaNav--link"
    }, item.title));
  }), /*#__PURE__*/React.createElement("li", {
    key: "languageSwitcher"
  }, /*#__PURE__*/React.createElement(MobileLanguageSwitcher, null))));
};
export var FlyoutClose = function FlyoutClose(param) {
  var title = param.title;
  var hideFlyout = useFlyout().hideFlyout;
  return /*#__PURE__*/React.createElement("button", {
    className: "MainNavFlyout--close",
    type: "button",
    onClick: function onClick() {
      return hideFlyout();
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "visuallyhidden"
  }, title), /*#__PURE__*/React.createElement("span", {
    className: "MainNavFlyout--closeIcon"
  }, /*#__PURE__*/React.createElement("span", {
    className: "MainNavFlyout--closeIcon--line"
  }), /*#__PURE__*/React.createElement("span", {
    className: "MainNavFlyout--closeIcon--line"
  })));
};
export var MobileLanguageSwitcher = function MobileLanguageSwitcher() {
  var domain = useDomain();
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale,
    locales = _useLocalization.locales;
  var _useLocation = _sliced_to_array(useLocation(), 2),
    navigate = _useLocation[1];
  var translationsMap = usePageTranslations();
  var translations = Object.fromEntries(translationsMap);
  var t = useTranslation().t;
  var hideMobileNavigation = useMobileNavigation().hideMobileNavigation;
  return Object.keys(translations).length ? /*#__PURE__*/React.createElement("form", {
    className: "MobileMetaNav--language"
  }, /*#__PURE__*/React.createElement("label", {
    className: "MobileMetaNav--language--label",
    htmlFor: "language"
  }, t("Language"), /*#__PURE__*/React.createElement("div", {
    className: "MobileMetaNav--language--select"
  }, /*#__PURE__*/React.createElement("select", {
    className: "MobileMetaNav--language--select",
    name: "language",
    defaultValue: locale,
    onChange: function onChange(e) {
      hideMobileNavigation();
      navigate(getLocalizedUrl({
        to: homepagePaths.includes(translations[e.target.value] || "") ? "/" : translations[e.target.value] || "",
        locale: e.target.value,
        domain: domain
      }).url);
    }
  }, Object.values(locales).map(function (param) {
    var code = param.code,
      name = param.name;
    return Object.keys(translations).includes(code) ? /*#__PURE__*/React.createElement("option", {
      key: code,
      value: code
    }, name) : null;
  }))))) : null;
};
export var MobileMenu = function MobileMenu(param) {
  var items = param.items,
    _param_isRoot = param.isRoot,
    isRoot = _param_isRoot === void 0 ? false : _param_isRoot;
  var domain = useDomain();
  var initialMenuState = items.reduce(function (menuState, item) {
    menuState[item.id] = false;
    return menuState;
  }, {});
  var _useState = _sliced_to_array(useState(initialMenuState), 2),
    menuState = _useState[0],
    setMenuState = _useState[1];
  var hideMobileNavigation = useMobileNavigation().hideMobileNavigation;
  return /*#__PURE__*/React.createElement("ul", {
    className: clsx("MobileMainNav--list", {
      "MobileMainNav--root": isRoot
    })
  }, items.map(function (item) {
    var _item_childItems, _item_attributes, _item_attributes1, _item_attributes2, _item_attributes3, _item_attributes4;
    var hasChildren = ((_item_childItems = item.childItems) === null || _item_childItems === void 0 ? void 0 : _item_childItems.length) || ((_item_attributes = item.attributes) === null || _item_attributes === void 0 ? void 0 : _item_attributes.id) && ["group", "aktuell"].includes((_item_attributes1 = item.attributes) === null || _item_attributes1 === void 0 ? void 0 : _item_attributes1.id);
    return /*#__PURE__*/React.createElement("li", {
      key: item.id,
      className: clsx("MobileMainNav--item", {
        "is-opened": menuState[item.id],
        "has-childs": hasChildren,
        "is-group": ((_item_attributes2 = item.attributes) === null || _item_attributes2 === void 0 ? void 0 : _item_attributes2.id) === "group" && item.attributes.ariaControls === "paraplegie--group" && domain.sidebarMenu !== "main",
        "MobileNav--cta MobileNav--cta-donation": ((_item_attributes3 = item.attributes) === null || _item_attributes3 === void 0 ? void 0 : _item_attributes3.id) === "group-donate",
        "MobileNav--cta MobileNav--cta-membership": ((_item_attributes4 = item.attributes) === null || _item_attributes4 === void 0 ? void 0 : _item_attributes4.id) === "group-member"
      })
    }, hasChildren ? /*#__PURE__*/React.createElement("a", {
      href: "",
      className: clsx("MobileMainNav--link", {
        "is-opened": menuState[item.id]
      }),
      onClick: function onClick(event) {
        event.preventDefault();
        setMenuState(_object_spread_props(_object_spread({}, initialMenuState), _define_property({}, item.id, !menuState[item.id])));
      }
    }, item.title) : /*#__PURE__*/React.createElement(Link, {
      href: item.url,
      className: "MobileMainNav--link",
      onClick: hideMobileNavigation
    }, item.title), item.childItems && /*#__PURE__*/React.createElement(MobileMenu, {
      items: item.childItems
    }));
  }));
};
export var MobileMainMenu = function MobileMainMenu(param) {
  var items = param.items;
  var locale = useLocalization().locale;
  var t = useTranslation().t;
  var domain = useDomain();
  var APP_CONFIG = appConfig();
  var transformMobileMainMenuItems = function transformMobileMainMenuItems(items) {
    return items.filter(function (item) {
      var _item_attributes, _item_attributes1;
      return !item.attributes || !((_item_attributes = item.attributes) === null || _item_attributes === void 0 ? void 0 : _item_attributes.id) || ((_item_attributes1 = item.attributes) === null || _item_attributes1 === void 0 ? void 0 : _item_attributes1.id) !== "search";
    }).map(function (item) {
      var _item_attributes;
      switch ((_item_attributes = item.attributes) === null || _item_attributes === void 0 ? void 0 : _item_attributes.id) {
        case "aktuell":
          return _object_spread_props(_object_spread({}, item), {
            childItems: [{
              id: "group-events",
              title: t("Events"),
              url: getLocalizedUrl({
                to: "/events",
                locale: locale
              }).url
            }]
          });
        default:
          return item;
      }
    });
  };
  var mainMenuItems = domain.id === "paraplegie_ch" ? transformMobileMainMenuItems(items) : [{
    id: "group",
    title: t("Paraplegiker-Gruppe"),
    url: "#",
    attributes: {
      id: "group",
      class: "has-childs",
      accessKey: "",
      ariaControls: "paraplegie--group"
    },
    childItems: [{
      id: "group-donate",
      title: t("Donate"),
      url: APP_CONFIG.donatePagePath[locale],
      attributes: {
        id: "group-donate",
        accessKey: "",
        class: "MobileMainNav--item MobileNav--cta MobileNav--cta-donation"
      }
    }, {
      id: "group-member",
      title: t("Become a member"),
      url: APP_CONFIG.memberPagePath[locale],
      attributes: {
        id: "group-member",
        accessKey: ""
      }
    }].concat(_to_consumable_array(transformMobileMainMenuItems(items)))
  }];
  return /*#__PURE__*/React.createElement(MobileMenu, {
    isRoot: true,
    items: mainMenuItems
  });
};
var SiteSearchContext = /*#__PURE__*/React.createContext(undefined);
export var SiteSearchProvider = function SiteSearchProvider(param) {
  var children = param.children;
  var hideFlyout = useFlyout().hideFlyout;
  var _useState = _sliced_to_array(useState(false), 2),
    isSiteSearchVisible = _useState[0],
    setIsVisible = _useState[1];
  var showSearch = function showSearch() {
    hideFlyout();
    setIsVisible(true);
  };
  var hideSearch = function hideSearch() {
    return setIsVisible(false);
  };
  return /*#__PURE__*/React.createElement(SiteSearchContext.Provider, {
    value: {
      isSiteSearchVisible: isSiteSearchVisible,
      showSearch: showSearch,
      hideSearch: hideSearch
    }
  }, children);
};
export var useSiteSearch = function useSiteSearch() {
  var context = useContext(SiteSearchContext);
  if (context === undefined) {
    throw new Error("useSiteSearch must be used within a SiteSearchProvider");
  }
  return context;
};
var MobileNavigationContext = /*#__PURE__*/React.createContext(undefined);
export var MobileNavigationProvider = function MobileNavigationProvider(param) {
  var children = param.children;
  var hideFlyout = useFlyout().hideFlyout;
  var _useState = _sliced_to_array(useState(false), 2),
    isMobileNavigationVisible = _useState[0],
    setIsVisible = _useState[1];
  var showMobileNavigation = function showMobileNavigation() {
    document.documentElement.classList.add("MobileNav-is-active");
    hideFlyout();
    setIsVisible(true);
  };
  var hideMobileNavigation = function hideMobileNavigation() {
    document.documentElement.classList.remove("MobileNav-is-active");
    setIsVisible(false);
  };
  var toggleMobileNavigation = function toggleMobileNavigation() {
    return isMobileNavigationVisible ? hideMobileNavigation() : showMobileNavigation();
  };
  return /*#__PURE__*/React.createElement(MobileNavigationContext.Provider, {
    value: {
      isMobileNavigationVisible: isMobileNavigationVisible,
      showMobileNavigation: showMobileNavigation,
      hideMobileNavigation: hideMobileNavigation,
      toggleMobileNavigation: toggleMobileNavigation
    }
  }, children);
};
export var useMobileNavigation = function useMobileNavigation() {
  var context = useContext(MobileNavigationContext);
  if (context === undefined) {
    throw new Error("useMobileNavigation must be used within a MobileNavigationProvider");
  }
  return context;
};
var SearchForm = function SearchForm(param) {
  var className = param.className;
  var t = useTranslation().t;
  var _useSearchForm = _sliced_to_array(useSearchForm(), 2),
    onSubmit = _useSearchForm[0],
    register = _useSearchForm[1];
  var domain = useDomain();
  var _useSiteSearch = useSiteSearch(),
    isSiteSearchVisible = _useSiteSearch.isSiteSearchVisible,
    hideSearch = _useSiteSearch.hideSearch;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx("SiteSearch", className, {
      "is-visible": isSiteSearchVisible
    })
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: onSubmit,
    className: "SiteSearch--form",
    method: "GET"
  }, /*#__PURE__*/React.createElement("label", {
    className: "visuallyhidden",
    htmlFor: "site-search"
  }, t("Search term")), /*#__PURE__*/React.createElement("input", _object_spread_props(_object_spread({
    className: "SiteSearch--input",
    id: "site-search"
  }, register("search")), {
    placeholder: t("Search on Paraplegie.ch"),
    type: "text"
  })), domain.id !== "paraplegie_ch" && /*#__PURE__*/React.createElement("input", _object_spread({
    type: "hidden"
  }, register("domain"))), /*#__PURE__*/React.createElement("button", {
    className: "SiteSearch--submit",
    type: "submit"
  }, /*#__PURE__*/React.createElement("span", {
    className: "visuallyhidden"
  }, t("Search")))), /*#__PURE__*/React.createElement("button", {
    className: "SiteSearch--close",
    type: "button",
    onClick: function onClick() {
      return hideSearch();
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "visuallyhidden"
  }, t("Close search")), /*#__PURE__*/React.createElement("i", {
    className: "SiteSearch--close--icon"
  })));
};
export var MetaNavigationMenu = function MetaNavigationMenu(param) {
  var items = param.items,
    itemsLeft = param.itemsLeft,
    title = param.title;
  var locale = useLocalization().locale;
  var t = useTranslation().t;
  var showSearch = useSiteSearch().showSearch;
  var APP_CONFIG = appConfig();
  var domain = useDomain();
  return /*#__PURE__*/React.createElement("nav", {
    className: "MetaNav"
  }, /*#__PURE__*/React.createElement(SecondaryTitle, {
    className: "visuallyhidden"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "MetaNav--left"
  }, domain.id === "orthotecsports_paraplegie_ch" ?
  // Hardcoded menu for Orthotecsports domain.
  /*#__PURE__*/
  React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
    className: "MetaNav--link MetaNav--title no-par-mini-logo",
    href: APP_CONFIG.orthotecPagePath[locale]
  }, t("orthotec_paraplegie_ch.title")), /*#__PURE__*/React.createElement("span", {
    className: "MetaNav--sub-text"
  }, t("A part of")), /*#__PURE__*/React.createElement(Link, {
    className: "MetaNav--link MetaNav--title par-mini-logo",
    href: APP_CONFIG.groupPagePath[locale]
  }, t("Paraplegiker-Gruppe"))) :
  // Dynamic menu for other domains.
  /*#__PURE__*/
  React.createElement(React.Fragment, null, domain.id !== "paraplegie_ch" && /*#__PURE__*/React.createElement("span", {
    className: "MetaNav--sub-text"
  }, t("A part of")), itemsLeft.map(function (item) {
    return /*#__PURE__*/React.createElement(Link, {
      key: "".concat(item.id),
      className: "MetaNav--link MetaNav--title",
      href: item.url
    }, item.title);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "MetaNav--right"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "MetaNav--list"
  }, addClassToMenuItems("MetaNav--link")(items).map(function (menuItem) {
    var _menuItem_attributes;
    return ((_menuItem_attributes = menuItem.attributes) === null || _menuItem_attributes === void 0 ? void 0 : _menuItem_attributes.id) === "search" ? /*#__PURE__*/React.createElement(MenuItem, _object_spread_props(_object_spread({
      className: "search",
      key: "".concat(menuItem.id)
    }, menuItem), {
      onClick: function onClick(event) {
        event.preventDefault();
        showSearch();
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "visuallyhidden"
    }, "$", menuItem.title), /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "41",
      height: "41",
      viewBox: "0 0 41 41"
    }, /*#__PURE__*/React.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("ellipse", {
      cx: "24.357",
      cy: "17.321",
      stroke: "currentColor",
      rx: "9",
      ry: "9.321"
    }), /*#__PURE__*/React.createElement("path", {
      stroke: "currentColor",
      strokeLinecap: "square",
      d: "M17.9285714,24.0714288 L8.26430961,33.7356906"
    })))) : /*#__PURE__*/React.createElement(DomainProvider, {
      domain: "paraplegie_ch",
      key: "".concat(menuItem.id)
    }, /*#__PURE__*/React.createElement(MenuItem, _object_spread_props(_object_spread({}, menuItem), {
      localDomain: domain
    })));
  }), /*#__PURE__*/React.createElement(LanguageSwitcher, null))));
};
export var LanguageSwitcher = function LanguageSwitcher() {
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale,
    locales = _useLocalization.locales;
  var translationsMap = usePageTranslations();
  var translations = Object.fromEntries(translationsMap);
  var _useState = _sliced_to_array(useState(false), 2),
    isVisible = _useState[0],
    setIsVisible = _useState[1];
  return Object.keys(translations).length ? /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
    className: "Flyout"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-haspopup": "true",
    className: "Flyout--trigger js-Flyout--trigger MetaNav--link LanguageSelectorFlyout--link",
    type: "button",
    accessKey: "5",
    onClick: function onClick() {
      return setIsVisible(true);
    }
  }, locale.toUpperCase()), /*#__PURE__*/React.createElement("div", {
    className: clsx("Flyout--overlay", {
      "is-visible": isVisible
    }),
    onClick: function onClick() {
      return setIsVisible(false);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx("Flyout--container align-right LanguageSelectorFlyout", {
      "is-visible": isVisible
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "Flyout--container--arrow"
  }), /*#__PURE__*/React.createElement("div", {
    className: "Flyout--content"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "Flyout--list"
  }, Object.values(locales).map(function (param) {
    var code = param.code,
      name = param.name;
    return Object.keys(translations).includes(code) ? /*#__PURE__*/React.createElement("li", {
      className: "Flyout--item",
      key: "".concat(code)
    }, /*#__PURE__*/React.createElement(Link, {
      href: getLocalizedUrl({
        to: translations[code] || "/",
        locale: code
      }).url,
      className: clsx("Flyout--item--link", {
        "is-active": locale === code
      })
    }, name)) : null;
  })))))) : null;
};
export var transformMainMenuItems = function transformMainMenuItems(domain) {
  return function (items) {
    return items.map(function (menuItem) {
      return _object_spread_props(_object_spread({}, menuItem), {
        childItems: undefined
      });
    }).filter(function (menuItem) {
      var _menuItem_attributes, _menuItem_attributes1;
      return domain.ignoreAriaControls || ((_menuItem_attributes = menuItem.attributes) === null || _menuItem_attributes === void 0 ? void 0 : _menuItem_attributes.ariaControls) && ((_menuItem_attributes1 = menuItem.attributes) === null || _menuItem_attributes1 === void 0 ? void 0 : _menuItem_attributes1.ariaControls.length) > 0;
    });
  };
};
export var MainMenu = function MainMenu(param) {
  var items = param.items,
    _param_hideCtasHeader = param.hideCtasHeader,
    hideCtasHeader = _param_hideCtasHeader === void 0 ? false : _param_hideCtasHeader;
  var domain = useDomain();
  var t = useTranslation().t;
  var activeFlyout = useFlyout().activeFlyout;
  var mainMenuItems = flow(transformMainMenuItems(domain), addClassToMenuItems("MainNav--link", {
    clickable: domain.clickableMainMenu
  }))(items);
  var primaryCallToAction = useCallToAction("primary");
  var secondaryCallToAction = useCallToAction("secondary");
  return /*#__PURE__*/React.createElement("nav", {
    className: clsx("MainNav", {
      "is-flyoutOpened": !!activeFlyout
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "MainNav--left"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "MainNav--categories"
  }, mainMenuItems.map(function (menuItem) {
    return /*#__PURE__*/React.createElement(MenuItem, _object_spread({
      key: "menu-".concat(menuItem.id)
    }, menuItem));
  }))), domain.id === "paraplegie_ch" && !hideCtasHeader && /*#__PURE__*/React.createElement("div", {
    className: "MainNav--right"
  }, secondaryCallToAction && /*#__PURE__*/React.createElement(Link, {
    className: "Button icon-before cta-white secondary",
    type: "button",
    href: secondaryCallToAction.url
  }, /*#__PURE__*/React.createElement("i", {
    className: clsx("before", "ico", "inline", "primary", "ico-".concat(secondaryCallToAction.type, "-blue"))
  }), /*#__PURE__*/React.createElement("span", {
    className: "Button--text"
  }, t("cta.button_type.".concat(secondaryCallToAction.type)))), primaryCallToAction && /*#__PURE__*/React.createElement(Link, {
    className: "Button icon-before cta-red",
    type: "button",
    href: primaryCallToAction.url
  }, /*#__PURE__*/React.createElement("i", {
    className: clsx("before", "ico", "inline", "ico-".concat(primaryCallToAction.type, "-white"))
  }), /*#__PURE__*/React.createElement("span", {
    className: "Button--text"
  }, t("cta.button_type.".concat(primaryCallToAction.type))))));
};
var MobileNavigation = function MobileNavigation(param) {
  var className = param.className,
    _param_hideCtasHeader = param.hideCtasHeader,
    hideCtasHeader = _param_hideCtasHeader === void 0 ? false : _param_hideCtasHeader;
  var domain = useDomain();
  var t = useTranslation().t;
  var isMobileNavigationVisible = useMobileNavigation().isMobileNavigationVisible;
  var locale = useLocalization().locale;
  var menus = useOperation(AllMenusQuery);
  var mobileMainMenuItems = menuItems(domain.mainMenu || "main", menus.data, locale);
  var mobileMetaNavigationMenuItems = menuItems(domain.metaNavigationMenu || "meta-navigation", menus.data, locale);
  var mobileMetaNavigationMenuItemsLeft = menuItems("meta-navigation-left", menus.data, locale);
  var mobileSidebarMenuItems = menuItems(domain.sidebarMenu || "main", menus.data, locale);
  var primaryCallToAction = useCallToAction("primary");
  var secondaryCallToAction = useCallToAction("secondary");
  return /*#__PURE__*/React.createElement("div", {
    className: clsx("MobileNav", className, {
      "is-active": isMobileNavigationVisible
    })
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "MobileNav--search"
  }, /*#__PURE__*/React.createElement(SearchForm, {
    className: "static"
  })), domain.id === "paraplegie_ch" && !hideCtasHeader && /*#__PURE__*/React.createElement("div", {
    className: "MobileNav--ctas"
  }, secondaryCallToAction && /*#__PURE__*/React.createElement("button", {
    className: "Button icon-before cta-white",
    type: "button"
  }, /*#__PURE__*/React.createElement("a", {
    type: "button",
    href: secondaryCallToAction.url
  }, /*#__PURE__*/React.createElement("i", {
    className: clsx("before", "ico", "inline", "ico-".concat(secondaryCallToAction.type, "-red"))
  }), /*#__PURE__*/React.createElement("span", {
    className: "Button--text"
  }, t("cta.button_type.".concat(secondaryCallToAction.type))))), primaryCallToAction && /*#__PURE__*/React.createElement("button", {
    className: "Button icon-before cta-red",
    type: "button"
  }, /*#__PURE__*/React.createElement("a", {
    type: "button",
    href: primaryCallToAction.url
  }, /*#__PURE__*/React.createElement("i", {
    className: clsx("before", "ico", "inline", "ico-".concat(primaryCallToAction.type, "-white"))
  }), /*#__PURE__*/React.createElement("span", {
    className: "Button--text"
  }, t("cta.button_type.".concat(primaryCallToAction.type)))))), !domain.hideSidebarOnMobile && /*#__PURE__*/React.createElement("div", {
    className: "MobileNav--menu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "MobileMainNav themed"
  }, /*#__PURE__*/React.createElement(SecondaryTitle, {
    className: "visuallyhidden"
  }, "".concat(t(domain.name), " Navigation")), /*#__PURE__*/React.createElement(MobileMenu, {
    items: mobileSidebarMenuItems
  }))), /*#__PURE__*/React.createElement("div", {
    className: clsx("MobileNav--menu", {
      "is-active": domain.hideSidebarOnMobile
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "MobileMainNav"
  }, /*#__PURE__*/React.createElement("span", {
    className: "visuallyhidden"
  }, t("Main navigation")), /*#__PURE__*/React.createElement(MobileMainMenu, {
    items: mobileMainMenuItems
  })), /*#__PURE__*/React.createElement(MobileMetaNavigationMenu, {
    title: t("Meta navigation"),
    items: mobileMetaNavigationMenuItems,
    itemsLeft: mobileMetaNavigationMenuItemsLeft
  }))));
};
var HeaderFlyoutOrganisation = function HeaderFlyoutOrganisation() {
  var t = useTranslation().t;
  var activeFlyout = useFlyout().activeFlyout;
  var locale = useLocalization().locale;
  var domain = useDomain();
  var menus = useOperation(AllMenusQuery);
  var items = menuItems(domain.sidebarMenu || "main", menus.data, locale);
  return /*#__PURE__*/React.createElement(React.Fragment, null, items.filter(function (menuItem) {
    var _menuItem_attributes;
    return (_menuItem_attributes = menuItem.attributes) === null || _menuItem_attributes === void 0 ? void 0 : _menuItem_attributes.ariaControls;
  }).map(function (item, index) {
    var _item_attributes, _item_attributes1, _item_attributes2;
    var key = "".concat(item.attributes.id, "--").concat(index);
    return ((_item_attributes = item.attributes) === null || _item_attributes === void 0 ? void 0 : _item_attributes.enabled) && /*#__PURE__*/React.createElement("div", {
      "aria-expanded": activeFlyout === ((_item_attributes1 = item.attributes) === null || _item_attributes1 === void 0 ? void 0 : _item_attributes1.ariaControls),
      "aria-labelledby": item.attributes.id,
      className: clsx("MainNavFlyout", {
        "is-visible": activeFlyout === ((_item_attributes2 = item.attributes) === null || _item_attributes2 === void 0 ? void 0 : _item_attributes2.ariaControls)
      }),
      role: item.attributes.id,
      key: key
    }, /*#__PURE__*/React.createElement("div", {
      className: "MainNavFlyout--content"
    }, /*#__PURE__*/React.createElement(SecondaryTitle, {
      className: "visuallyhidden"
    }, t("{{section}} Subnavigation", {
      section: t(item.attributes.id)
    })), /*#__PURE__*/React.createElement("div", {
      className: "MainNavFlyout--nav",
      role: "list"
    }, item.childItems && /*#__PURE__*/React.createElement("ul", {
      className: "MainNavFlyout--categories"
    }, item.childItems.map(function (secondLevelItem) {
      var _secondLevelItem_attributes, _secondLevelItem_attributes1;
      return ((_secondLevelItem_attributes = secondLevelItem.attributes) === null || _secondLevelItem_attributes === void 0 ? void 0 : _secondLevelItem_attributes.enabled) && /*#__PURE__*/React.createElement("li", {
        key: secondLevelItem.id,
        className: "MainNavFlyout--category"
      }, /*#__PURE__*/React.createElement(Link, {
        className: "MainNavFlyout--category--titleLink",
        href: secondLevelItem.url,
        target: ((_secondLevelItem_attributes1 = secondLevelItem.attributes) === null || _secondLevelItem_attributes1 === void 0 ? void 0 : _secondLevelItem_attributes1.target) || "_self"
      }, /*#__PURE__*/React.createElement("div", {
        className: "MainNavFlyout--title"
      }, secondLevelItem.title)), secondLevelItem.childItems && /*#__PURE__*/React.createElement("ul", {
        className: "MainNavFlyout--category--list"
      }, secondLevelItem.childItems.map(function (thirdLevelItem) {
        var _thirdLevelItem_attributes, _thirdLevelItem_attributes1;
        return ((_thirdLevelItem_attributes = thirdLevelItem.attributes) === null || _thirdLevelItem_attributes === void 0 ? void 0 : _thirdLevelItem_attributes.enabled) && /*#__PURE__*/React.createElement("li", {
          key: "".concat(thirdLevelItem.id)
        }, /*#__PURE__*/React.createElement(Link, {
          className: "MainNavFlyout--category--link",
          href: thirdLevelItem.url,
          target: ((_thirdLevelItem_attributes1 = thirdLevelItem.attributes) === null || _thirdLevelItem_attributes1 === void 0 ? void 0 : _thirdLevelItem_attributes1.target) || "_self"
        }, thirdLevelItem.title));
      })));
    })))), /*#__PURE__*/React.createElement(FlyoutClose, {
      title: t('Close "Group" Flyout')
    }));
  }));
};
var FastNavigationMenu = function FastNavigationMenu(param) {
  var items = param.items,
    title = param.title;
  return /*#__PURE__*/React.createElement("nav", {
    "aria-describedby": "Skiplinks--h3",
    className: "Skiplinks",
    id: "Skiplinks"
  }, /*#__PURE__*/React.createElement(SecondaryTitle, {
    title: title,
    className: "visuallyhidden",
    id: "Skiplinks--h3"
  }), /*#__PURE__*/React.createElement("ul", null, items.map(function (menuItem) {
    return /*#__PURE__*/React.createElement(MenuItem, _object_spread({
      key: "".concat(menuItem.id)
    }, menuItem));
  })));
};
var MobileNavigationToggle = function MobileNavigationToggle(param) {
  var title = param.title;
  var _useMobileNavigation = useMobileNavigation(),
    isMobileNavigationVisible = _useMobileNavigation.isMobileNavigationVisible,
    toggleMobileNavigation = _useMobileNavigation.toggleMobileNavigation;
  return /*#__PURE__*/React.createElement("button", {
    "aria-expanded": "false",
    "aria-haspopup": "true",
    type: "button",
    className: clsx("MobileNav--toggle MobilNavToggles--button", {
      "is-active": isMobileNavigationVisible
    }),
    onClick: toggleMobileNavigation
  }, /*#__PURE__*/React.createElement("span", {
    className: "visuallyhidden"
  }, title), /*#__PURE__*/React.createElement("span", {
    className: "MobileNavToggle--burger"
  }, /*#__PURE__*/React.createElement("span", {
    className: "MobileNavToggle--burger--line"
  }), /*#__PURE__*/React.createElement("span", {
    className: "MobileNavToggle--burger--line"
  }), /*#__PURE__*/React.createElement("span", {
    className: "MobileNavToggle--burger--line"
  })));
};
export var Header = function Header(param) {
  var _param_hideHeader = param.hideHeader,
    hideHeader = _param_hideHeader === void 0 ? false : _param_hideHeader,
    _param_hideCtasHeader = param.hideCtasHeader,
    hideCtasHeader = _param_hideCtasHeader === void 0 ? false : _param_hideCtasHeader;
  var domain = useDomain();
  var _useFlyout = useFlyout(),
    activeFlyout = _useFlyout.activeFlyout,
    hideFlyout = _useFlyout.hideFlyout;
  var t = useTranslation().t;
  var _useSiteSearch = useSiteSearch(),
    isSiteSearchVisible = _useSiteSearch.isSiteSearchVisible,
    hideSearch = _useSiteSearch.hideSearch;
  var _useMobileNavigation = useMobileNavigation(),
    isMobileNavigationVisible = _useMobileNavigation.isMobileNavigationVisible,
    hideMobileNavigation = _useMobileNavigation.hideMobileNavigation;
  var _useOperation = useOperation(AllMenusQuery),
    menus = _useOperation.data;
  var locale = useLocalization().locale;
  var mainMenuItems = menuItems(domain.sidebarMenu || "main", menus, locale);
  var metaNavigationMenuItems = menuItems(domain.metaNavigationMenu || "meta-navigation", menus, locale);
  var metaNavigationMenuItemsLeft = menuItems("meta-navigation-left", menus, locale);
  var fastNavigationMenuItems = menuItems("fast-navigation-menu", menus, locale);
  var primaryCallToAction = useCallToAction("primary");
  var _useState = _sliced_to_array(useState(false), 2),
    isLoaded = _useState[0],
    setIsLoaded = _useState[1];
  useEffect(function () {
    setTimeout(function () {
      setIsLoaded(true);
    }, 20);
  }, [isLoaded]);
  return /*#__PURE__*/React.createElement("header", {
    className: clsx("SiteHeader", {
      "no-metanav": hideHeader,
      "is-search-visible": isSiteSearchVisible
    })
  }, /*#__PURE__*/React.createElement(SecondaryTitle, {
    className: "visuallyhidden"
  }, t("Navigation area")), /*#__PURE__*/React.createElement(FastNavigationMenu, {
    title: "Fast Navigation Menu",
    items: fastNavigationMenuItems
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx("SiteHeader--overlay", {
      "is-visible": isSiteSearchVisible || isMobileNavigationVisible || !!activeFlyout
    }),
    onClick: function onClick() {
      hideFlyout();
      hideSearch();
      hideMobileNavigation();
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "SiteHeader--spacer"
  }), /*#__PURE__*/React.createElement("div", {
    className: "SiteHeader--sticky"
  }, /*#__PURE__*/React.createElement("div", {
    className: "SiteHeader--inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "SiteHeader--logo"
  }, isLoaded && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Logo, {
    isDesktop: true
  }), /*#__PURE__*/React.createElement(Logo, null))), hideHeader && /*#__PURE__*/React.createElement("div", {
    className: "SiteHeader--nav is-hideHeader",
    id: "site-navigation"
  }, /*#__PURE__*/React.createElement("div", {
    className: "SiteHeader--navContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "SiteHeader--mainNavWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "SiteHeader--logo-par"
  }, /*#__PURE__*/React.createElement(Logo, {
    isDesktop: true,
    isWhiteLogo: true
  }))))), !hideHeader && /*#__PURE__*/React.createElement("div", {
    className: "SiteHeader--nav",
    id: "site-navigation"
  }, /*#__PURE__*/React.createElement("div", {
    className: "SiteHeader--navContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "SiteHeader--metaNavWrapper"
  }, /*#__PURE__*/React.createElement(MetaNavigationMenu, {
    title: "Meta navigation menu",
    items: metaNavigationMenuItems,
    itemsLeft: metaNavigationMenuItemsLeft
  })), /*#__PURE__*/React.createElement("div", {
    className: "SiteHeader--mainNavWrapper"
  }, domain.id === "paraplegie_ch" && /*#__PURE__*/React.createElement("div", {
    className: "SiteHeader--logo-par"
  }, activeFlyout ? /*#__PURE__*/React.createElement(Logo, {
    isDesktop: true,
    noPadding: true
  }) : /*#__PURE__*/React.createElement(Logo, {
    isDesktop: true,
    isWhiteLogo: true
  })), /*#__PURE__*/React.createElement(MainMenu, {
    title: "Main Menu",
    items: mainMenuItems,
    hideCtasHeader: hideCtasHeader
  })), /*#__PURE__*/React.createElement("div", {
    className: "SiteHeader--navIndicator"
  }, /*#__PURE__*/React.createElement("div", {
    className: "SiteHeader--navIndicator--indicationBar"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "SiteHeader--mobileNav"
  }, /*#__PURE__*/React.createElement("div", {
    className: "MobileNavToggles"
  }, domain.id === "paraplegie_ch" && !hideCtasHeader && primaryCallToAction && /*#__PURE__*/React.createElement(Link, {
    className: "Button icon-before cta-red",
    href: primaryCallToAction.url
  }, /*#__PURE__*/React.createElement("i", {
    className: clsx("before", "ico", "inline", "ico-".concat(primaryCallToAction.type, "-white"))
  }), /*#__PURE__*/React.createElement("span", {
    className: "Button--text"
  }, t("cta.button_type.".concat(primaryCallToAction.type)))), /*#__PURE__*/React.createElement(MobileNavigationToggle, {
    title: t("Open navigation")
  })))), /*#__PURE__*/React.createElement("div", {
    className: "SiteHeader--searchContainer"
  }, !hideHeader && /*#__PURE__*/React.createElement(SearchForm, null))), /*#__PURE__*/React.createElement("div", {
    className: "SiteHeader--flyoutContainer"
  }, /*#__PURE__*/React.createElement(HeaderFlyoutOrganisation, null))), !hideHeader && /*#__PURE__*/React.createElement(MobileNavigation, {
    hideCtasHeader: hideCtasHeader
  }));
};